import { reportSGM, isIOS } from '@jdt-jinke/jdpay_utils'
import { sleep } from '@/hooks/useTools'

/**
 * app环境
 */
export function runEnvironment() {
  const isJDJR = /jdjr-app/i
  const isJDAPP = /jdapp/i
  const miniProgram = /miniProgram/i
  const isJdpingou = /jdpingou/i
  const UA = window.navigator.userAgent.toLocaleLowerCase()
  let environment = ''
  if (isJDAPP.test(UA)) {
    environment = 'jd'
  } else if (isJDJR.test(UA)) {
    environment = 'jdjr'
  } else if (miniProgram.test(UA)) {
    environment = 'miniProgram'
  } else if (isJdpingou.test(UA)) {
    environment = 'jdpingou'
  }
  return environment
}

/**
 *  唤起京东app
 */
export function openJdApp(id, options = {}) {
  const opt = {
    inteneUrl: 'openApp.jdMobile://virtual?',
    M_sourceFrom: 'jpay',
    inteneUrlParams: {
      category: 'jump',
      des: 'm',
      url: location.href,
      ...(options || {})
    },
    autoOpenAppEventId: 'MDownLoadFloat_AppArouse',
    autoOpenAppEventParam: 'EventIdParam',
    autoOpenIntervalTime: '1',
    cookieFlag: 'honeyCard',
    NoJumpDownLoadPage: true,
    openAppBtnId: id
  }

  console.log('openJdApp', id, opt)

  if (window.$ && typeof window.$.downloadAppPlugIn === 'function') {
    console.log('openJdApp__MDownLoadFloat_AppArouse')

    window.$.downloadAppPlugInOpenApp(opt)
    setTimeout(() => {
      const oBtn = document.createElement('button')
      oBtn.addEventListener(
        'click',
        () => {
          window.$.downloadAppPlugIn(opt)
        },
        false
      )
      const e = document.createEvent('MouseEvents')
      e.initEvent('click', true, true)
      oBtn.dispatchEvent(e)
    }, 100)
  } else {
    showToast('请您在京东APP内打开')
    const el = document.getElementById(id)
    if (el) {
      el.style.display = 'none'
    }

    reportSGM({
      code: 'openJdAppError',
      res: {
        id,
        opt
      }
    })
  }
}

/**
 * 联盟跟单核心参数
 */

// 导出一个名为getUnplFromNative的函数，用于从原生环境获取unpl数据
export function getUnplFromNative() {
  // 定义一个回调函数名称，原生代码将通过这个名称调用回调
  const callBackName: string = 'window.h5GetUnpl'
  // 定义传递给原生应用的参数，包括业务类型和回调函数名称
  const param = {
    businessType: 'unpl',
    callBackName
  }

  // 返回一个新的Promise对象
  return new Promise<string>(function (resolve) {
    // 在全局对象window上定义h5GetUnpl函数，用于接收原生应用的回调
    window.h5GetUnpl = function (res: string) {
      try {
        // 尝试解析从原生应用传回的JSON字符串
        const {
          data: { unpl }
        } = JSON.parse(res)
        // 如果解析成功且unpl数据存在
        if (unpl) {
          // 将unpl数据设置为cookie
          document.cookie = 'unpl=' + unpl + ';path=/;domain=.jd.com '
        } else {
          // 如果unpl数据为空，报告错误
          reportSGM({ code: 'shopping_card_getUnplFromNative_empty', type: 3 })
        }
        // 使用Promise的resolve函数返回unpl数据
        resolve(unpl)
      } catch (error) {
        // 如果解析过程中出现错误，报告错误并返回空值
        reportSGM({ code: 'shopping_card_getUnplFromNative_error', type: 3 })
        resolve('')
      }
    }

    // 调用CallJdSdk函数与原生应用通信，并将结果存储在sdkCallSuccessful变量中
    const sdkCallSuccessful = CallJdSdk('notifyMessageToNative', param)
    // 如果与原生应用通信失败
    if (!sdkCallSuccessful) resolve('') // 立即解析Promise为空值

    // 设置一个超时，如果在1秒内没有收到原生应用的回调，解析Promise为空值
    sleep(1000, () => resolve(''))
  })
}

/** 京东APP方法调用
 * @param {*} type 方法名
 * @param {*} params 方法入参
 */
function CallJdSdk(type: string = 'notifyMessageToNative', param = {}) {
  try {
    // 将参数对象转换为JSON字符串
    const jsonString = JSON.stringify(param)
    // 判断当前设备是否为iOS
    if (isIOS) {
      // iOS设备通过webkit的messageHandlers调用原生方法
      window.webkit.messageHandlers.JDAppUnite.postMessage({
        method: type, // 方法类型
        params: jsonString // 传递给原生方法的参数
      })
    } else {
      // 非iOS设备直接调用window下的JDAppUnite对象的方法
      window.JDAppUnite[type](jsonString)
    }
    // 调用成功返回true
    return true
  } catch (error) {
    // 捕获异常并上报
    reportSGM({
      code: `shopping_card_CallJdSdk_${type}_error`,
      error,
      type: 3
    })
    // 发生异常返回false
    return false
  }
}

/** 动态加载 script 脚本 */
export function loadScript(url: string, payload: Record<string, any> = {}) {
  const s = document.createElement('script')
  s.src = url
  s.async = payload?.async || false
  s.crossOrigin = 'anonymous'
  s.onload = function () {
    s.remove()
    typeof payload?.callback === 'function' && payload.callback()
  }
  ;(document.head || document.documentElement).appendChild(s)
}
